module.exports = __webpack_public_path__ + "static/media/brassgrab.8088fd73.webp";